// import { Alert, AlertDescription } from '@chakra-ui/react';

export const FailedToLoad = () => (
  <div>Something went wrong. Please try later.</div>
);
